import { Header } from "@/types/VDataTable";
export const headers: Header[] = [
  {
    text: "ID",
    type: "string",
    align: "left",
    value: "id",
    sortable: true,
    class: "id",
    width: "95px",
  },
  {
    text: "Vessel Access Group Name",
    type: "string",
    align: "left",
    value: "name",
    class: "name",
    sortable: true,
  },
  {
    text: "Number of Vessels",
    type: "string",
    align: "left",
    value: "vesselCount",
    sortable: true,
    class: "vesselCount",
    width: "180px",
  },
  {
    text: "Number of Users",
    type: "string",
    align: "left",
    value: "userCount",
    sortable: true,
    class: "userCount",
    width: "180px",
  },
  {
    text: "Actions",
    type: "actions",
    align: "left",
    value: "actions",
    sortable: false,
    class: "actions",
    width: "220px",
  },
];
